import { render, staticRenderFns } from "./textContainerCom.vue?vue&type=template&id=429de4af"
import script from "./textContainerCom.vue?vue&type=script&lang=js"
export * from "./textContainerCom.vue?vue&type=script&lang=js"
import style0 from "./textContainerCom.vue?vue&type=style&index=0&id=429de4af&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports